function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function overrideRange() {
  var prevRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
  var newRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0];
  // This prevents the first element "Any" from being included in the range

  if (prevRange.includes(0)) {
    return [Math.max(...newRange)];
  }
  if (newRange.includes(0) || newRange.length === 0) {
    return [0];
  }
  return newRange;
}
function rangeToArray(range, top) {
  if (!range.min) {
    return range.max ? [1, range.max] : [0];
  }
  if (!range.max) {
    return [range.min, top];
  }
  return [range.min, range.max];
}
function valuesToRange(min, max, top) {
  return _objectSpread(_objectSpread({}, min && {
    min
  }), max && max !== top && {
    max
  });
}
function arrayToRange(array, top) {
  if (array.length === 0) {
    return {};
  }
  if (array.length === 1) {
    return valuesToRange(array[0], array[0], top);
  }
  return valuesToRange(array[0], array[1], top);
}
function getItems(max) {
  return [...Array(max + 1).keys()].map(index => ({
    label: index ? "".concat(index).concat(index === max ? '+' : '') : 'Any',
    value: String(index)
  }));
}
export default overrideRange;
export { arrayToRange, getItems, rangeToArray };